export default function RecommendationDirective() {
  return {
    template: require('./recommendation.html'),
    scope: {
      auditId: '=',
      recommendationCategoryId: '=',
      recommendation: '=',
      auditIsActive: '=',
      deleteCallback: '&',
    },
    controller: 'RecommendationController',
    controllerAs: 'recommendationVM',
    bindToController: true,
    replace: true
  };
}
